import { render, staticRenderFns } from "./SpecItems.vue?vue&type=template&id=621fec36&scoped=true&"
import script from "./SpecItems.vue?vue&type=script&lang=js&"
export * from "./SpecItems.vue?vue&type=script&lang=js&"
import style0 from "./SpecItems.vue?vue&type=style&index=0&id=621fec36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621fec36",
  null
  
)

export default component.exports